module.exports = __webpack_public_path__ + "img/icon.018d41c7.png";